import { SCRIPT_LOADING_STATE, usePayPalScriptReducer } from '@paypal/react-paypal-js';

export function useLoadPayPalSDK(isEnabled: boolean = false) {
  if (!isEnabled) {
    return {
      loadPayPalScript: () => {},
    };
  }

  const [_, dispatch] = usePayPalScriptReducer();

  return {
    loadPayPalScript: () =>
      dispatch({
        type: 'setLoadingStatus',
        value: SCRIPT_LOADING_STATE.PENDING,
      }),
  };
}
